import axios from '@/mod/axiosMod';

export default {
  // wiki: https://km.sankuai.com/page/1228661868

  /**
   * 获取生效中的活动
   */
  getActivity() {
    return axios.post('/api/bill/v2/agreement/myAgreement');
  },

  /**
   * 获取活动列表
   */
  getActivityList(pageNum, pageSize) {
    const postData = { pageNum, pageSize };
    return axios.post('/api/bill/v2/agreement/list', postData);
  },

  /**
   * 获取 指定活动 详情
   */
  getActivityDetail(activityId) {
    const postData = { agreementId: activityId };
    return axios.post('/api/bill/v2/agreement/detail', postData);
  },

  /**
   * 获取 未支付 列表
   */
  getUnPaidList(customerId) {
    const postData = {
      customerId,
    };
    return axios.post('/api/agreement/v1/unpaid', postData);
  },

  /**
   * 获取 退款 详情
   */
  getRefundInfo(activityId) {
    const postData = {
      agreementId: activityId,
      refundType: 1,
    };
    return axios.get('/api/bill/v2/agreement/merchant/refund/info', { params: postData });
  },

  /**
   * 发起 退款下单
   */
  submitRefundOrder(postData) {
    return axios.post('/api/bill/v2/agreement/refund', postData);
  },

  /**
   * 获取 指定活动 GTV（月明细）
   */
  getActivityMonthGTVList(customerId, activityId) {
    const postData = { agreementId: activityId, customerId };
    return axios.post('/api/bill/v2/agreement/monthDivideGtvList', postData);
  },

  /**
   * 条件付 指定月份 账单明细（门店列表）
   */
  getActivityMonthGTV(customerId, activityId, billMonth) {
    const postData = { customerId, agreementId: activityId, billMonth };
    return axios.post('/api/bill/v2/agreement/monthDivideGtv', postData);
  },

  /**
   * 条件付 指定门店 指定月 账单明细（日明细）
   */
  getActivityDayGTVList(customerId, activityId, billMonth, poiId) {
    const postData = {
      customerId, agreementId: activityId, billMonth, poiId,
    };
    return axios.post('/api/bill/v2/agreement/dayGtvList', postData);
  },

  /**
   * 条件付 指定门店 指定日 GTV流水
   */
  getActivityDayPoiGTVFlow(customerId, activityId, day, poiId, billMonth, pageNum, pageSize) {
    const postData = {
      customerId, agreementId: activityId, day, poiId, billMonth, pageNum, pageSize,
    };
    return axios.post('/api/bill/v2/agreement/dayPoiGtvFlow', postData);
  },

  /**
   * 指定活动 收款详情
   */
  getActivityGTVDetail(customerId, activityId) {
    const postData = {
      customerId, agreementId: activityId,
    };
    return axios.post('/api/bill/v2/agreement/paidFlow', postData);
  },

};
